/* eslint-disable no-await-in-loop -- attempts are sequential by design */

const defaultSleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Whether an error is worth retrying: network failures (no HTTP status) and 408, 429, 5xx.
 * Reads the status from `error.status` (fetch wrappers) or `error.response.status` (axios).
 */
export function isTransientError(error) {
  const status = error?.status ?? error?.response?.status;
  if (status === undefined) {
    return true;
  }
  return status === 408 || status === 429 || status >= 500;
}

/**
 * Calls `fn` until it resolves, waiting `delaysMs[i]` before retry number i + 1.
 * Makes at most `delaysMs.length + 1` calls. Rethrows the last error when it gives up
 * or when `shouldRetry` rejects the error.
 */
export async function retry(fn, {
  delaysMs = [1000, 3000, 10000],
  shouldRetry = isTransientError,
  sleep = defaultSleep,
} = {}) {
  for (let attempt = 0; ; attempt += 1) {
    try {
      return await fn(attempt);
    } catch (error) {
      if (attempt >= delaysMs.length || !shouldRetry(error, attempt)) {
        throw error;
      }
      await sleep(delaysMs[attempt]);
    }
  }
}
